import { useTranslation } from '@eti/providers';
import { useHistory } from 'react-router-dom';
import ErrorDialog from '../../../common/error-modals/ErrorDialog';
import { RESULT_SEARCH_NOT_POSSIBLE } from '../../../constants/dataLayerEventsConstants';
import { routes as routesConstants } from '../../../constants/routesAndApisConstants';

const NoSearchPossibleModal = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const onPrimaryAction = () => history.push(routesConstants.START);

  return (
    <ErrorDialog
      content={t('Result.NoSearch.Modal.Content')}
      data-testid="noSearch-dialog"
      dataLayerEvent={RESULT_SEARCH_NOT_POSSIBLE}
      isOpen
      onPrimaryAction={onPrimaryAction}
      primaryButtonLabel={t('Result.NoSearch.Modal.PrimaryAction.Label')}
      title={t('Result.NoSearch.Modal.Title')}
    />
  );
};

export default NoSearchPossibleModal;
